import { React, useState, useEffect, useContext } from "react";
import "../../components/CSS/Profile/starProfile/starPhotos.css";

import StarProfileRightContent from "./StarCardComponent/StarProfileRightContent/StarProfileRightContent";
import Lock from "../../Assets/Images/Normal-User/lock.png";
import StarPhotosDetails from "./StarPhotosDetails";
import axios from "axios";
import {
  LocationContext,
  userPostPaymentCheck,
} from "../../CustomHelper/Helper";
import PaymentModal from "../../components/Modal/PaymentModal/PaymentModal";
import NodataAvailable from "../Common/NodataAvailable";
import { serverInfo } from "../../App";
import MyVerticallyCenteredModal from "../RegisterLearningDetails/RegisterNowPay/MyVerticallyCenteredModal";

export default function StarPhotos({ star_id }) {
  const { imageCdnUrl } = useContext(serverInfo);

  const [post, setPost] = useState([]);
  const [successShow, setSuccessShow] = useState(false);
  const [post_id, setPostId] = useState(false);
  const [fee, setFee] = useState("");
  const [payment_status, setPaymentStatus] = useState("lock");
  const [photosUpdate, setUnlocked] = useState(false);
  const [lockStatus, setLockStatus] = useState([]);
  const { paymentCount, paymentCountWithSymbol, payStatus } =
    useContext(LocationContext);

  const makePayment = (id) => {
    setPostId(id[0]);
    setFee(id[1]);
    setSuccessShow(true);
  };

  const getPhotos = () => {
    axios.get(`api/star_photos/${star_id}`).then((res) => {
      if (res.data.status === 200) {
        setPost(res.data.post);
      }
    });
    axios.get(`api/user/generalPost/payment/check`).then((res) => {
      if (res.data.status === 200) {
        setLockStatus(res.data.lockStatus);
      }
    });
    setUnlocked(false);
  };

  useEffect(() => {
    getPhotos();
  }, [photosUpdate]);

  return (
    <div className="container StarContainer">
      <div className="row">
        <div className="col-sm-12 col-lg-8 mt-3">
          <div className="card m-2 star-photos-card mx-auto pb-3">
            <div className="card-body">
              <h5 className="card-title text-warning">Photos</h5>
            </div>
            <div className="star-line"></div>

            <div className="card-body mb-2">
              <div className="row text-center">
                {post.length > 0 ? (
                  post.map((postData) => (
                    <>
                      {postData.type == "paid" ? (
                        <>
                          {postData.image ? (
                            <div className="col-4 mb-3">
                              <div style={{ position: "relative" }}>
                                <img
                                  src={imageCdnUrl + postData.image}
                                  alt=""
                                  // className="img-fluid star-card-left-photos ImgBlur"
                                  className={
                                    userPostPaymentCheck(
                                      postData.id,
                                      lockStatus
                                    ) === false
                                      ? "divDisable ImgBlur img-fluid star-card-left-photos"
                                      : "img-fluid star-card-left-photos"
                                  }
                                />

                                {userPostPaymentCheck(
                                  postData.id,
                                  lockStatus
                                ) === false ? (
                                  <img
                                    src={Lock}
                                    alt=""
                                    className="ImGCernterP"
                                    onClick={() =>
                                      makePayment([postData?.id, postData?.fee])
                                    }
                                  />
                                ) : null}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </>
                      ) : (
                        <>
                          {postData.image ? (
                            <div className="col-4 mb-3">
                              <img
                                src={imageCdnUrl + postData.image}
                                alt=""
                                className="img-fluid star-card-left-photos"
                              />
                            </div>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </>
                  ))
                ) : (
                  <NodataAvailable className="mt-5" />
                )}
              </div>
            </div>

            <MyVerticallyCenteredModal
              show={successShow}
              onHide={() => setSuccessShow(false)}
              event_id={post_id}
              fee={paymentCount(fee)}
              baseFee={fee}
              event_type="generalpost"
              redirectTo="activities"
            />
          </div>
        </div>

        <div className="col-md-4">
          <StarProfileRightContent star_id={star_id} />
        </div>
      </div>
    </div>
  );
}
